import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgAlertArrows = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.707 6.24597C17.4917 4.88777 15.8927 3.93055 14.1215 3.50093C12.3503 3.07132 10.4904 3.18956 8.78792 3.84003C7.0854 4.49049 5.62049 5.64251 4.58698 7.14368C3.55347 8.64485 3.00007 10.4244 3 12.247V13"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.29297 18.249C6.50821 19.6071 8.10714 20.5643 9.87823 20.994C11.6493 21.4236 13.5091 21.3055 15.2116 20.6551C16.9141 20.0048 18.379 18.8529 19.4126 17.3519C20.4462 15.8509 20.9997 14.0715 21 12.249V11.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 13.7469L21 11.4969L23.25 13.7469"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 10.7469L3 12.9969L0.75 10.7469"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 6.99695V12.9969"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16C11.9258 16 11.8533 16.022 11.7917 16.0632C11.73 16.1044 11.6819 16.163 11.6535 16.2315C11.6252 16.3 11.6177 16.3754 11.6322 16.4482C11.6467 16.5209 11.6824 16.5877 11.7348 16.6402C11.7873 16.6926 11.8541 16.7283 11.9268 16.7428C11.9996 16.7573 12.075 16.7498 12.1435 16.7215C12.212 16.6931 12.2706 16.645 12.3118 16.5833C12.353 16.5217 12.375 16.4492 12.375 16.375C12.375 16.2755 12.3355 16.1802 12.2652 16.1098C12.1948 16.0395 12.0995 16 12 16"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgAlertArrows.displayName = 'SvgAlertArrows';
export default SvgAlertArrows;
